export enum GALLERY_TYPE {
    IMAGE = "IMAGE",
    VDO = "VIDEO",
    ALL = "ALL"
}